module.exports = __webpack_public_path__ + "img/indus-pic-3.71c373ab.png";